/* eslint-disable no-use-before-define */
import React from 'react'
import { fmt } from '../../twd'

export default ({data, dataModule='overview-quick-ideas', dataCategory='quick-ideas', dataName='overview-quick-ideas', showFrequency=false} = {}) => (
    <tr
    data-module={dataModule}
    data-category={dataCategory}
    data-name={dataName + '-row'}>
    <td className="text-left text-truncate" style={{maxWidth:'240px'}}>{
        fmt.issuer({
            issuer:data.holdIssue,
            cusip:data.holdCusip,
            from:'overview',
            dataModule:dataModule,
            dataCategory:dataCategory,
        })
    }</td>
    <td>{ data.holdMaturity }</td>
    <td>{ formatYield(data.askYield) }</td>
    <td className="text-right">{
        showFrequency
        ? data.couponPaymentFreq || freq(data.holdCouponFrequency)
        : (<React.Fragment>
            {fmt.nvl(data.moodyRating)}/{fmt.nvl(data.spRating)}
        </React.Fragment>)
    }</td>
    <td className="text-right">{ fmt.price(data.askPrice) }</td>
    </tr>
)


const freq = (a) => {
    return a===null ? 'At Maturity' :
        a>=365 ? 'Annually' :
        a>=182 ? 'Semiannual' :
        a>=80 ? 'Quarterly' :
        a>=28 ? 'Monthly' :
        ''
}

let formatYield = (x) => {
    let a = parseFloat(x)
    if (isNaN(a)) return '-'

    let s = a.toFixed(3)
    if (s==='0.000') return '-'
    return s + '%'
}